import { render, staticRenderFns } from "./jobs.vue?vue&type=template&id=821066be&scoped=true&"
import script from "./jobs.vue?vue&type=script&lang=ts&"
export * from "./jobs.vue?vue&type=script&lang=ts&"
import style0 from "./jobs.vue?vue&type=style&index=0&id=821066be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821066be",
  null
  
)

component.options.__file = "jobs.vue"
export default component.exports